import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";

import { NotFound } from "@app/shared/ErrorPages";
import { QASTutorials, QESTutorials } from "@app/tutorials";
import { JSX } from "react";

/** Renders the routing components for the tutorials sub-section of the app. */
export default function TutorialsRouter(props: RouteComponentProps): JSX.Element {
  return (
    <Switch>
      <Redirect strict={true} exact={true} from={`${props.match.path}`} to={`${props.match.path}/qas`} />
      <Route path={`${props.match.path}/qas`} component={QASTutorials} />
      <Route path={`${props.match.path}/qes`} component={QESTutorials} />
      <Route component={NotFound} />
    </Switch>
  );
}
